// import { createApp } from "vue";
// import App from "./App.vue";
// import router from "./router";
// import "@/assets/css/reset.css";
// import ElementPlus from "element-plus";
// import "element-plus/dist/index.css";
// import zhCn from "element-plus/es/locale/lang/zh-cn";
// import VXETable from "vxe-table";
// import "vxe-table/lib/style.css";
// import { createPinia } from "pinia";

// createApp(App)
//   .use(VXETable)
//   .use(ElementPlus, {
//     locale: zhCn
//   })
//   .use(createPinia())
//   .use(router)
//   .mount("#app");

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/reset.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import { createPinia } from "pinia";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// ==============================================================================
// 全局拦截报错 (采用更安全的包装模式，彻底解决 Element Plus 崩溃问题)
// ==============================================================================
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver {
  observer: any;
  constructor(callback: any) {
    let timer: any = null;
    const debouncedCallback = (entries: any, observer: any) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        callback(entries, observer);
      }, 16);
    };
    // 关键修复：直接使用 new 实例化原生对象，避开 extends 编译带来的坑
    this.observer = new _ResizeObserver(debouncedCallback);
  }
  observe(target: Element, options?: any) {
    this.observer.observe(target, options);
  }
  unobserve(target: Element) {
    this.observer.unobserve(target);
  }
  disconnect() {
    this.observer.disconnect();
  }
} as any;
// ==============================================================================

const app = createApp(App);
app
  .use(VXETable)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(createPinia())
  .use(router)
  .mount("#app");

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
